import { Fragment, useState } from "react";
import { motion } from "framer-motion";
import Popups from "../Modals/Popups";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";
import useWindowWidth from "../../hooks/useWindowWidth";

const MotionSwitch = ({
  isMobile,
  as = "div",
  className,
  children,
  initial,
  inView,
  transition,
  ...rest
}) => {
  const Tag = as;
  if (!isMobile) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }
  const MotionTag = motion[as] ?? motion.div;
  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={inView}
      viewport={{ once: true, amount: 0.5 }}
      transition={transition ?? { duration: 0.6, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default function Cta() {
  const width = useWindowWidth();
  const [show, setShow] = useState(false);
  const isMobile = width <= 768;

  return (
    <Fragment>
      <div className="container-fluid horizontal-padding">
        <div className="row a2-portfolio-crm-bg ps-md-5 mx-0">
          <MotionSwitch
            isMobile={isMobile}
            as="div"
            className="col-md-12 col-12 px-md-5 py-md-5 py-4 my-md-3 my-3 text-center"
            initial={{ scale: 0.5, opacity: 0 }}
            inView={{ scale: [1.1, 1], opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut", bounce: 0.4 }}
          >
            <h2 className="font-1">Your business, your way!</h2>
            <h3 className="font-2">
              Custom CRM Development brings your ideas to life with precision
              and impact.
            </h3>
            <button
              className="btn-a2-portfolio-border mt-md-4 mt-2"
              onClick={() => setShow(true)}
            >
              <div className="btn-a2-portfolio p-md-3 px-3 py-2 d-flex align-items-center justify-content-center">
                Tell us your goals
                <img className="ms-3" src="/images/a2-right-arrow.png" alt="" />
              </div>
            </button>
          </MotionSwitch>
        </div>
      </div>
      <Popups show={show} setShow={setShow} title="FREE CONSULTATION" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </Fragment>
  );
}
